/**
 * Atualização da PWA (doc 12.2). O service worker é registrado em modo "prompt":
 * quando um deploy novo é publicado, o app NÃO recarrega sozinho — ele detecta a
 * versão (checagem periódica enquanto fica aberto em campo) e avisa para atualizar
 * com 1 toque. Mantém a fila de sync intacta (ela vive no localStorage, sobrevive
 * ao reload).
 */
import { registerSW } from "virtual:pwa-register";

/** De quanto em quanto tempo perguntar ao SW se há nova versão (app aberto). */
const INTERVALO_CHECAGEM_MS = 60_000;

type Ouvinte = (disponivel: boolean) => void;

let ouvintes: Ouvinte[] = [];
let disponivel = false;
let aplicar: ((recarregar?: boolean) => Promise<void>) | null = null;

/** Registra o SW e começa a checar atualizações. Chamar uma vez, no boot. */
export function iniciarPwa(): void {
  if (typeof window === "undefined") {
    return;
  }
  aplicar = registerSW({
    immediate: true,
    onNeedRefresh() {
      disponivel = true;
      for (const o of ouvintes) {
        o(true);
      }
    },
    onRegisteredSW(_url, registro) {
      if (registro) {
        // Checa periodicamente: pega o deploy mesmo com o app aberto o dia todo.
        setInterval(() => {
          void registro.update();
        }, INTERVALO_CHECAGEM_MS);
      }
    },
  });
}

/** Assina o aviso "nova versão". Devolve o cancelamento. */
export function assinarAtualizacao(o: Ouvinte): () => void {
  ouvintes.push(o);
  o(disponivel);
  return () => {
    ouvintes = ouvintes.filter((x) => x !== o);
  };
}

/** Ativa a nova versão e recarrega. */
export function aplicarAtualizacao(): void {
  void aplicar?.(true);
}
